import { Loader as ReshapedLoader } from "reshaped";

type SpinnerSize = "small" | "normal" | "big";

const spinnerSize: Record<SpinnerSize, "small" | "medium" | "large"> = {
    small: "small",
    normal: "medium",
    big: "large",
};

type SpinnerProps = {
    size?: SpinnerSize;
};

export default function Spinner(props: SpinnerProps) {
    const { size = "normal" } = props;
    return <ReshapedLoader size={spinnerSize[size]} ariaLabel="Chargement" />;
}
